module.exports = __webpack_public_path__ + "static/media/beyondblue.a3ccc913.png";